import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      color: palette.text.primary,
      marginBottom: '10px'
    },
    line1: {
      display: 'flex',
      gap: '10px',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    line2: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    line3: {
      display: 'flex'
    },
    nom: {
      fontSize: '16px',
      fontWeight: 600
    },
    infos: {
      fontSize: '16px',
      fontWeight: 500,
      margin: 0
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
